import React from "react";
import { TrendingUp, Link as LinkIcon, Leaf, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const advantages = [{
  title: "Financial Impact",
  description: "Even small concentrations of platinum group metals can generate significant return at scale. Recovery programs turn disposal costs into revenue, reduce lifecycle cost, improve asset planning, and create measurable return from end-of-life materials.",
  icon: TrendingUp
}, {
  title: "Supply Chain Stability",
  description: "Platinum and palladium mining is geographically concentrated, creating volatility and risk. Recovery returns metals to the supply chain, reducing dependence on primary mining and strengthening long-term procurement planning.",
  icon: LinkIcon
}, {
  title: "Environmental Responsibility",
  description: "Recovering metals reduces greenhouse gas emissions, industrial waste, energy use, and natural resource extraction compared to new mining. Supports measurable sustainability goals.",
  icon: Leaf
}, {
  title: "Regulatory Readiness",
  description: "Many catalyst materials require proper processing rather than landfill disposal. Recovery supports compliance, reduces environmental liability, and maintains documentation for reporting.",
  icon: ShieldCheck
}];
export default function StrategicIndustrialAdvantages() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="strategic-industrial-advantages" ref={sectionRef} className="dark text-foreground py-16 px-4 relative overflow-hidden !bg-[hsl(210,17%,98%)]">
      <div className="mx-auto max-w-[1440px]" style={{
      backgroundImage: 'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }}>
        <div className={cn("mb-12 text-center transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl font-bold tracking-tight mb-4 !text-[hsl(0,0%,0%)] md:text-4xl">
            Strategic Industrial Advantages
          </h2>
          <p className="text-lg max-w-2xl mx-auto !text-[hsl(210,11%,15%)]">
            Why Catalyst Recovery Matters
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((item, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 ease-out transform h-full", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 h-full border-muted backdrop-blur-sm transition-colors duration-300 border !bg-[hsl(0,0%,9%)] hover:bg-secondary/80">
                <CardHeader className="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 ![padding:0px_24px_8px_24px]">
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-accent text-ring">
                    <item.icon className="size-6" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="leading-relaxed text-sm !text-[hsl(210,17%,98%)]">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}